import { Icon } from "@iconify/react";
import axios from "axios";
import React, { useRef, useState, useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { getCookie } from "../GetCookie";

const OTPVerification = () => {
  const [otp, setOtp] = useState(Array(6).fill(""));
  const phoneOtpRefs = useRef([]);
  const navigate = useNavigate();
  const [verificationError, setVerificationError] = useState("");
  const [timer, setTimer] = useState(52);
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const location = useLocation();
  const email = location.state?.email || "";
  // Timer for OTP resend
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setIsResendEnabled(true);
    }
  }, [timer]);

  // Handle OTP input change

  const handleOtpChange = (index, value) => {
    if (!/^\d*$/.test(value)) return; // Allow only numbers

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1); // Store only the last entered digit
    setOtp(newOtp);

    setVerificationError(""); // Clear error message when user starts typing

    // Move to next input field if a digit is entered
    if (value && index < otp.length - 1) {
      phoneOtpRefs.current[index + 1].focus();
    }
  };

  // Handle backspace key
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      phoneOtpRefs.current[index - 1].focus();
    }
  };

  // Handle OTP verification
  const handleVerify = async () => {
    const enteredOtp = otp.join("");
    console.log("OTP entered:", enteredOtp);

    if (enteredOtp.length < 6) {
      setVerificationError("Please enter all 6 digits.");
      return;
    }

    // const token =localStorage.getItem('token');
    const token = getCookie("token");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/forgot-password/verify-otp`,
        {
          email: email,
          otp: enteredOtp,
        },
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        toast.success("Verified OTP Successfully.");
        navigate("/forgot-password/createnewpassword", {
          state: {
            email: email,
            emailVerificationToken: response.data?.randomToken, // ✅ Assuming this comes from backend
          },
        });
        console.log(response.data.randomToken);
      }

      console.log(response.data);
    } catch (error) {
      toast.error(error.message);
      console.error(
        "Error:",
        error.response ? error.response.data : error.message
      );
    }
    setVerificationError("");
  };

  // Add OTP verification logic here (API call, etc.)

  // Handle Resend OTP
  const handleResend = () => {
    setOtp(Array(6).fill(""));
    setTimer(52);
    setIsResendEnabled(false);
    setVerificationError("");
    console.log("Resend OTP requested");
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "#EBFAFF" }}
    >
      <Toaster position="top-right" reverseOrder={false} />
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div
          className="modal-content border-0 px-5 py-4"
          style={{
            boxShadow: "0px 0px 43px 0px #0000000D",
            borderRadius: "20px",
            maxHeight:"500px"
          }}
        >
          {/* Back Button */}
          <div
            className="d-flex align-items-center mt-3 gap-1"
            style={{ color: "#909090", cursor: "pointer" }}
            onClick={() => navigate(-1)}
          >
            <Icon icon="ep:back" className="fw-bold fs-4" />
            <h6 className="fw-normal fs-6 pt-2">Back</h6>
          </div>

          {/* OTP Title */}
          <div className="modal-body">
            <h5
              className="fw-bold fs-4"
              style={{ fontFamily: "Noto Sans, sans-serif" }}
            >
              OTP Code Verification
            </h5>
            <p className="text-secondary">
              Please enter the code sent to your email
            </p>
          </div>

          {/* OTP Inputs - Centered */}
          <div className="d-flex justify-content-center gap-2 mb-3">
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                maxLength={1}
                value={digit}
                className="form-control text-center fs-5"
                ref={(ref) => (phoneOtpRefs.current[index] = ref)}
                style={{
                  width: "40px",
                  height: "40px",
                  border: "1px solid #229EBD",
                }}
                onChange={(e) => handleOtpChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                autoFocus={index === 0}
              />
            ))}
          </div>
          <h6 className="fs-6 fw-normal text-secondary text-center mb-3">
            Didn’t received the code{" "}
          </h6>

          {/* Error Message */}
          {verificationError && (
            <p className="text-danger text-center">{verificationError}</p>
          )}

          {/* Resend OTP Timer */}
          <div className="d-flex justify-content-between align-items-center px-5 mb-3">
            <h6 className="fs-6 fw-semibold" style={{ color: "#606060" }}>
              {timer > 0
                ? `00:${timer < 10 ? `0${timer}` : timer}`
                : "Time expired"}
            </h6>
            <button
              className="btn  text-decoration-none fs-6 fw-normal rounded-pill"
              onClick={handleResend}
              disabled={!isResendEnabled}
              style={{
                background: "#F4FFE1",
                border: " 1px solid #229EBD",
                color: "#229EBD",
                // color: isResendEnabled ? '#007bff' : '#909090', cursor: isResendEnabled ? 'pointer' : 'not-allowed'
              }}
            >
              Resend OTP
            </button>
          </div>

          {/* Verify OTP Button */}
          <div className="d-flex justify-content-center">
            <button
  type="button"
  style={{
    backgroundColor: "#00AFEF",     // green button
    color: "#fff",                  // white text
    padding: "12px 24px",           // vertical and horizontal padding
    margin: "16px 0",               // top and bottom margin
    border: "none",                 // remove default border
    borderRadius: "50px",          // rounded-pill style
    width: "75%",                  // simulate w-75
    maxWidth: "250px",              // optional for desktop scaling
    fontWeight: "500",              // simulate bold-ish font
    fontSize: "16px",               // readable size
    cursor: "pointer",              // hand icon on hover
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)", // subtle depth
    transition: "background-color 0.3s ease",
  }}
  onClick={handleVerify}
>
  Verify OTP
</button>

          </div>
        </div>
      </div>
    </div>
  );
};

export default OTPVerification;
